@if (store.asArray(); as helps) {
  <p-table
    #helpTable
    [globalFilterFields]="['name']"
    [paginator]="helps.length > 10"
    [rows]="10"
    [rowsPerPageOptions]="[10, 20, 50]"
    [loading]="loading"
    [value]="helps">
    <ng-template pTemplate="caption">
      <app-table-list-caption
        [searchWord]="searchWord"
        (clearTable)="clear(helpTable)"
        (search)="
          helpTable.filterGlobal($event, 'contains')
        "></app-table-list-caption>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th>Schlüssel</th>
        <th>Name</th>
        <th>Aktionen</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-help>
      <tr>
        <td>
          <code>{{ help.key }}</code>
        </td>
        <td>
          <span class="flex align-items-center gap-3"
            ><i class="fas fa-book"></i> {{ help.name }}</span
          >
        </td>
        <td>
          <a
            pButton
            class="p-button-rounded p-button-xs p-button-primary mr-2"
            icon="fas fa-user-plus"
            [routerLink]="[
              { outlets: { bearbeiten: [help._id, 'user', 'neu'] } },
            ]"></a>

          <app-table-list-actions
            [item]="help"
            (confirm)="confirm($event, help, help.name)">
          </app-table-list-actions>
        </td>
      </tr>
    </ng-template>
  </p-table>
} @else {
  <div role="alert" class="p-message p-message-info">
    <div class="p-message-wrapper">
      <span class="p-message-summary">404</span>
      <span class="p-message-detail">Keine Kommunen gefunden</span>
    </div>
  </div>
}

<p-sidebar
  (onHide)="onOverlayClose()"
  position="right"
  [modal]="false"
  [styleClass]="'w-7'"
  [visible]="editFormOverlay">
  <ng-template pTemplate="header">
    <app-header
      [icon]="editFormOverlayIcon"
      [text]="editFormOverlayHeader"></app-header
  ></ng-template>

  <ng-container *ngIf="editFormOverlay">
    <router-outlet name="bearbeiten"></router-outlet>
  </ng-container>
</p-sidebar>
<app-mask [visible]="editFormOverlay" (click)="onOverlayClose()"></app-mask>
